import React from "react";
import theme from "../theme/theme1";
 
const ScholarshipExam = () => {
  return (
    <div
      className="flex flex-col items-center py-12 bg-white"
      style={{ fontFamily: theme.ScholarshipExam.fontFamily }}
    >
      {/* Heading */}
      <h1
        className={`${theme.ScholarshipExam.headingSize} ${theme.ScholarshipExam.headingFontWeight} ${theme.ScholarshipExam.headingLetterSpacing} mb-10 uppercase`}
        style={{ color: theme.ScholarshipExam.headingColor }}
      >
        IIT / NEET Scholarship Exam 2024-25
      </h1>

      {/* Buttons Container */}
      <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6">
        {/* Left Button - Model Question Paper */}
        <div
          className={`text-center py-10 px-16 rounded-lg ${theme.ScholarshipExam.button1.shadow} cursor-pointer transform transition duration-300 hover:scale-105`}
          style={{
            backgroundColor: theme.ScholarshipExam.button1.backgroundColor,
            color: theme.ScholarshipExam.button1.textColor,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor =
              theme.ScholarshipExam.button1.hoverBackgroundColor)
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor =
              theme.ScholarshipExam.button1.backgroundColor)
          }
        >
          <p className={`${theme.ScholarshipExam.button1.fontWeight} ${theme.ScholarshipExam.button1.fontSize} leading-relaxed`}>
            Download <br /> Model Question Paper
          </p>
        </div>

        {/* Right Button - I-Quest */}
        <div
          className={`text-center py-10 px-16 rounded-lg ${theme.ScholarshipExam.button2.shadow} cursor-pointer transform transition duration-300 hover:scale-105`}
          style={{
            backgroundColor: theme.ScholarshipExam.button2.backgroundColor,
            color: theme.ScholarshipExam.button2.textColor,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor =
              theme.ScholarshipExam.button2.hoverBackgroundColor)
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor =
              theme.ScholarshipExam.button2.backgroundColor)
          }
        >
          <p className={`${theme.ScholarshipExam.button2.fontWeight} ${theme.ScholarshipExam.button2.fontSize} leading-relaxed`}>
            Download <br /> I-Quest
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScholarshipExam;
